import * as React from 'react';
import { PreviewMode } from '../preview-elements/preview-context';
export var SuggestionPreviewWrapper = function (props) {
    return (React.createElement(PreviewMode.Consumer, null, function (value) { return (value.isPreview ? null : props.children); }));
};
//# sourceMappingURL=suggestions-wrapper.js.map